module.exports = __webpack_public_path__ + "img/meble.721d1458.svg";